import { ISupportingActor } from '@dadohr/shared/domainTypes/experience';
import { startCase } from 'lodash';

/**
 * Lightweight duplicate of `humanReadableActorName` from
 * services/experiences/template.ts. That file transitively imports
 * services/user/index.ts, which uses Vite-only `import.meta` syntax and
 * breaks under this repo's Jest config — so it can't be imported from this
 * module (see IssueCopyContext.humanReadableActorName in types.ts). Real
 * call sites pass the canonical implementation via context; this is only
 * the fallback used when a test (or a future caller) doesn't.
 */
export const defaultHumanReadableActorName = (
  actorKey: string,
  supportingActors: { [actorKey: string]: ISupportingActor } = {}
): string => {
  return (
    supportingActors[actorKey]?.name ||
    actorKey
      .split(/(?=[A-Z])/)
      .map(startCase)
      .join(' ')
  );
};
